import { useState } from 'react';
import pdfCourtFormsApiService from '~/src/services/api/pdfCourtFormsApiService';

export function useTemplatePreview() {
  const [previewImages, setPreviewImages] = useState<string[] | null>(null);
  const [previewTitle, setPreviewTitle] = useState<string | null>(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);

  const openPreview = async (templateId: number, title: string) => {
    setPreviewTitle(title);
    setPreviewImages(null);
    setIsPreviewLoading(true);
    try {
      const response = await pdfCourtFormsApiService.getTemplatePreview(
        templateId,
      );
      const images = response.document.pages.map(
        (p: { background_url: string }) => p.background_url,
      );
      setPreviewImages(images);
    } catch {
      setPreviewImages([]);
    } finally {
      setIsPreviewLoading(false);
    }
  };

  const closePreview = () => {
    setPreviewImages(null);
    setPreviewTitle(null);
  };

  return {
    previewTitle,
    previewImages,
    isPreviewLoading,
    isPreviewOpen: isPreviewLoading || previewImages !== null,
    openPreview,
    closePreview,
  };
}
